export enum ECountry {
    AFGHANISTAN = "AF",
    ALBANIA = "AL",
    ALGERIA = "DZ",
    ANDORRA = "AD",
    ANGOLA = "AO",
    ANTIGUA_AND_BARBUDA = "AG",
    ARGENTINA = "AR",
    ARMENIA = "AM",
    AUSTRALIA = "AU",
    AUSTRIA = "AT",
    AZERBAIJAN = "AZ",
    BAHAMAS = "BS",
    BAHRAIN = "BH",
    BANGLADESH = "BD",
    BARBADOS = "BB",
    BELARUS = "BY",
    BELGIUM = "BE",
    BELIZE = "BZ",
    BENIN = "BJ",
    BHUTAN = "BT",
    BOLIVIA = "BO",
    BOSNIA_AND_HERZEGOVINA = "BA",
    BOTSWANA = "BW",
    BRAZIL = "BR",
    BRUNEI = "BN",
    BULGARIA = "BG",
    BURKINA_FASO = "BF",
    BURUNDI = "BI",
    CAMBODIA = "KH",
    CAMEROON = "CM",
    CANADA = "CA",
    CAPE_VERDE = "CV",
    CENTRAL_AFRICAN_REPUBLIC = "CF",
    CHAD = "TD",
    CHILE = "CL",
    CHINA = "CN",
    COLOMBIA = "CO",
    COMOROS = "KM",
    CONGO = "CG",
    COSTA_RICA = "CR",
    CROATIA = "HR",
    CUBA = "CU",
    CYPRUS = "CY",
    CZECH_REPUBLIC = "CZ",
    DENMARK = "DK",
    DJIBOUTI = "DJ",
    DOMINICA = "DM",
    DOMINICAN_REPUBLIC = "DO",
    ECUADOR = "EC",
    EGYPT = "EG",
    EL_SALVADOR = "SV",
    EQUATORIAL_GUINEA = "GQ",
    ERITREA = "ER",
    ESTONIA = "EE",
    ESWATINI = "SZ",
    ETHIOPIA = "ET",
    FIJI = "FJ",
    FINLAND = "FI",
    FRANCE = "FR",
    GABON = "GA",
    GAMBIA = "GM",
    GEORGIA = "GE",
    GERMANY = "DE",
    GHANA = "GH",
    GREECE = "GR",
    GRENADA = "GD",
    GUATEMALA = "GT",
    GUINEA = "GN",
    GUYANA = "GY",
    HAITI = "HT",
    HONDURAS = "HN",
    HUNGARY = "HU",
    ICELAND = "IS",
    INDIA = "IN",
    INDONESIA = "ID",
    IRAN = "IR",
    IRAQ = "IQ",
    IRELAND = "IE",
    ISRAEL = "IL",
    ITALY = "IT",
    JAMAICA = "JM",
    JAPAN = "JP",
    JORDAN = "JO",
    KAZAKHSTAN = "KZ",
    KENYA = "KE",
    KIRIBATI = "KI",
    KOREA_NORTH = "KP",
    KOREA_SOUTH = "KR",
    KUWAIT = "KW",
    KYRGYZSTAN = "KG",
    LAOS = "LA",
    LATVIA = "LV",
    LEBANON = "LB",
    LESOTHO = "LS",
    LIBERIA = "LR",
    LIBYA = "LY",
    LIECHTENSTEIN = "LI",
    LITHUANIA = "LT",
    LUXEMBOURG = "LU",
    MADAGASCAR = "MG",
    MALAWI = "MW",
    MALAYSIA = "MY",
    MALDIVES = "MV",
    MALI = "ML",
    MALTA = "MT",
    MAURITANIA = "MR",
    MAURITIUS = "MU",
    MEXICO = "MX",
    MOLDOVA = "MD",
    MONACO = "MC",
    MONGOLIA = "MN",
    MONTENEGRO = "ME",
    MOROCCO = "MA",
    MOZAMBIQUE = "MZ",
    MYANMAR = "MM",
    NAMIBIA = "NA",
    NAURU = "NR",
    NEPAL = "NP",
    NETHERLANDS = "NL",
    NEW_ZEALAND = "NZ",
    NICARAGUA = "NI",
    NIGER = "NE",
    NIGERIA = "NG",
    NORWAY = "NO",
    OMAN = "OM",
    PAKISTAN = "PK",
    PALAU = "PW",
    PANAMA = "PA",
    PAPUA_NEW_GUINEA = "PG",
    PARAGUAY = "PY",
    PERU = "PE",
    PHILIPPINES = "PH",
    POLAND = "PL",
    PORTUGAL = "PT",
    QATAR = "QA",
    ROMANIA = "RO",
    RUSSIA = "RU",
    RWANDA = "RW",
    SAUDI_ARABIA = "SA",
    SENEGAL = "SN",
    SERBIA = "RS",
    SINGAPORE = "SG",
    SLOVAKIA = "SK",
    SLOVENIA = "SI",
    SOUTH_AFRICA = "ZA",
    SPAIN = "ES",
    SWEDEN = "SE",
    SWITZERLAND = "CH",
    THAILAND = "TH",
    TURKEY = "TR",
    UKRAINE = "UA",
    UNITED_ARAB_EMIRATES = "AE",
    UNITED_KINGDOM = "GB",
    UNITED_STATES = "US",
    URUGUAY = "UY",
    VATICAN_CITY = "VA",
    VENEZUELA = "VE",
    VIETNAM = "VN",
    YEMEN = "YE",
    ZAMBIA = "ZM",
    ZIMBABWE = "ZW"
}

export const countriesToTextMapper = (country: ECountry | string) => {
    let c: ECountry;

    if(typeof country === 'string') {
        c = ECountry[country as keyof typeof ECountry];
    } else {
        c = country;
    }




    switch (country) {
        case ECountry.AFGHANISTAN: return "Afghanistan";
        case ECountry.ALBANIA: return "Albania";
        case ECountry.ALGERIA: return "Algeria";
        case ECountry.ANDORRA: return "Andorra";
        case ECountry.ANGOLA: return "Angola";
        case ECountry.ANTIGUA_AND_BARBUDA: return "Antigua and Barbuda";
        case ECountry.ARGENTINA: return "Argentina";
        case ECountry.ARMENIA: return "Armenia";
        case ECountry.AUSTRALIA: return "Australia";
        case ECountry.AUSTRIA: return "Austria";
        case ECountry.AZERBAIJAN: return "Azerbaijan";
        case ECountry.BAHAMAS: return "Bahamas";
        case ECountry.BAHRAIN: return "Bahrain";
        case ECountry.BANGLADESH: return "Bangladesh";
        case ECountry.BARBADOS: return "Barbados";
        case ECountry.BELARUS: return "Belarus";
        case ECountry.BELGIUM: return "Belgium";
        case ECountry.BELIZE: return "Belize";
        case ECountry.BENIN: return "Benin";
        case ECountry.BHUTAN: return "Bhutan";
        case ECountry.BOLIVIA: return "Bolivia";
        case ECountry.BOSNIA_AND_HERZEGOVINA: return "Bosnia and Herzegovina";
        case ECountry.BOTSWANA: return "Botswana";
        case ECountry.BRAZIL: return "Brazil";
        case ECountry.BRUNEI: return "Brunei";
        case ECountry.BULGARIA: return "Bulgaria";
        case ECountry.BURKINA_FASO: return "Burkina Faso";
        case ECountry.BURUNDI: return "Burundi";
        case ECountry.CAMBODIA: return "Cambodia";
        case ECountry.CAMEROON: return "Cameroon";
        case ECountry.CANADA: return "Canada";
        case ECountry.CAPE_VERDE: return "Cape Verde";
        case ECountry.CENTRAL_AFRICAN_REPUBLIC: return "Central African Republic";
        case ECountry.CHAD: return "Chad";
        case ECountry.CHILE: return "Chile";
        case ECountry.CHINA: return "China";
        case ECountry.COLOMBIA: return "Colombia";
        case ECountry.COMOROS: return "Comoros";
        case ECountry.CONGO: return "Congo";
        case ECountry.COSTA_RICA: return "Costa Rica";
        case ECountry.CROATIA: return "Croatia";
        case ECountry.CUBA: return "Cuba";
        case ECountry.CYPRUS: return "Cyprus";
        case ECountry.CZECH_REPUBLIC: return "Czech Republic";
        case ECountry.DENMARK: return "Denmark";
        case ECountry.DJIBOUTI: return "Djibouti";
        case ECountry.DOMINICA: return "Dominica";
        case ECountry.DOMINICAN_REPUBLIC: return "Dominican Republic";
        case ECountry.ECUADOR: return "Ecuador";
        case ECountry.EGYPT: return "Egypt";
        case ECountry.EL_SALVADOR: return "El Salvador";
        case ECountry.EQUATORIAL_GUINEA: return "Equatorial Guinea";
        case ECountry.ERITREA: return "Eritrea";
        case ECountry.ESTONIA: return "Estonia";
        case ECountry.ESWATINI: return "Eswatini";
        case ECountry.ETHIOPIA: return "Ethiopia";
        case ECountry.FIJI: return "Fiji";
        case ECountry.FINLAND: return "Finland";
        case ECountry.FRANCE: return "France";
        case ECountry.GABON: return "Gabon";
        case ECountry.GAMBIA: return "Gambia";
        case ECountry.GEORGIA: return "Georgia";
        case ECountry.GERMANY: return "Germany";
        case ECountry.GHANA: return "Ghana";
        case ECountry.GREECE: return "Greece";
        case ECountry.GRENADA: return "Grenada";
        case ECountry.GUATEMALA: return "Guatemala";
        case ECountry.GUINEA: return "Guinea";
        case ECountry.GUYANA: return "Guyana";
        case ECountry.HAITI: return "Haiti";
        case ECountry.HONDURAS: return "Honduras";
        case ECountry.HUNGARY: return "Hungary";
        case ECountry.ICELAND: return "Iceland";
        case ECountry.INDIA: return "India";
        case ECountry.INDONESIA: return "Indonesia";
        case ECountry.IRAN: return "Iran";
        case ECountry.IRAQ: return "Iraq";
        case ECountry.IRELAND: return "Ireland";
        case ECountry.ISRAEL: return "Israel";
        case ECountry.ITALY: return "Italy";
        case ECountry.JAMAICA: return "Jamaica";
        case ECountry.JAPAN: return "Japan";
        case ECountry.JORDAN: return "Jordan";
        case ECountry.KAZAKHSTAN: return "Kazakhstan";
        case ECountry.KENYA: return "Kenya";
        case ECountry.KIRIBATI: return "Kiribati";
        case ECountry.KOREA_NORTH: return "North Korea";
        case ECountry.KOREA_SOUTH: return "South Korea";
        case ECountry.KUWAIT: return "Kuwait";
        case ECountry.KYRGYZSTAN: return "Kyrgyzstan";
        case ECountry.LAOS: return "Laos";
        case ECountry.LATVIA: return "Latvia";
        case ECountry.LEBANON: return "Lebanon";
        case ECountry.LESOTHO: return "Lesotho";
        case ECountry.LIBERIA: return "Liberia";
        case ECountry.LIBYA: return "Libya";
        case ECountry.LIECHTENSTEIN: return "Liechtenstein";
        case ECountry.LITHUANIA: return "Lithuania";
        case ECountry.LUXEMBOURG: return "Luxembourg";
        case ECountry.MADAGASCAR: return "Madagascar";
        case ECountry.MALAWI: return "Malawi";
        case ECountry.MALAYSIA: return "Malaysia";
        case ECountry.MALDIVES: return "Maldives";
        case ECountry.MALI: return "Mali";
        case ECountry.MALTA: return "Malta";
        case ECountry.MAURITANIA: return "Mauritania";
        case ECountry.MAURITIUS: return "Mauritius";
        case ECountry.MEXICO: return "Mexico";
        case ECountry.MOLDOVA: return "Moldova";
        case ECountry.MONACO: return "Monaco";
        case ECountry.MONGOLIA: return "Mongolia";
        case ECountry.MONTENEGRO: return "Montenegro";
        case ECountry.MOROCCO: return "Morocco";
        case ECountry.MOZAMBIQUE: return "Mozambique";
        case ECountry.MYANMAR: return "Myanmar";
        case ECountry.NAMIBIA: return "Namibia";
        case ECountry.NAURU: return "Nauru";
        case ECountry.NEPAL: return "Nepal";
        case ECountry.NETHERLANDS: return "Netherlands";
        case ECountry.NEW_ZEALAND: return "New Zealand";
        case ECountry.NICARAGUA: return "Nicaragua";
        case ECountry.NIGER: return "Niger";
        case ECountry.NIGERIA: return "Nigeria";
        case ECountry.NORWAY: return "Norway";
        case ECountry.OMAN: return "Oman";
        case ECountry.PAKISTAN: return "Pakistan";
        case ECountry.PALAU: return "Palau";
        case ECountry.PANAMA: return "Panama";
        case ECountry.PAPUA_NEW_GUINEA: return "Papua New Guinea";
        case ECountry.PARAGUAY: return "Paraguay";
        case ECountry.PERU: return "Peru";
        case ECountry.PHILIPPINES: return "Philippines";
        case ECountry.POLAND: return "Poland";
        case ECountry.PORTUGAL: return "Portugal";
        case ECountry.QATAR: return "Qatar";
        case ECountry.ROMANIA: return "Romania";
        case ECountry.RUSSIA: return "Russia";
        case ECountry.RWANDA: return "Rwanda";
        case ECountry.SAUDI_ARABIA: return "Saudi Arabia";
        case ECountry.SENEGAL: return "Senegal";
        case ECountry.SERBIA: return "Serbia";
        case ECountry.SINGAPORE: return "Singapore";
        case ECountry.SLOVAKIA: return "Slovakia";
        case ECountry.SLOVENIA: return "Slovenia";
        case ECountry.SOUTH_AFRICA: return "ZA";
        case ECountry.SPAIN: return "Spain";
        case ECountry.SWEDEN: return "Sweden";
        case ECountry.SWITZERLAND: return "Switzerland";
        case ECountry.THAILAND: return "Thailand";
        case ECountry.TURKEY: return "Turkey";
        case ECountry.UKRAINE: return "Ukraine";
        case ECountry.UNITED_ARAB_EMIRATES: return "United Arab Emirates";
        case ECountry.UNITED_KINGDOM: return "United Kingdom";
        case ECountry.UNITED_STATES: return "United States";
        case ECountry.URUGUAY: return "Uruguay";
        case ECountry.VATICAN_CITY: return "Vatican";
        case ECountry.VENEZUELA: return "Venezuela";
        case ECountry.VIETNAM: return "Vietnam";
        case ECountry.YEMEN: return "Yemen";
        case ECountry.ZAMBIA: return "Zambia";
        case ECountry.ZIMBABWE: return "Zimbabwe";
        default: return "Other";
    }
}
